import { useMutation } from '@tanstack/react-query';
import { buildDeclineJoinRequestPayload } from '../components/Partner/Community/joinRequestDialogData';
import { declinePartnerGroupChannelJoinRequest } from '../services/partnerGroupChannel';

export const useDeclinePartnerGroupChannelJoinRequestMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ requestId, declineReasonCode, declineReasonText }) => {
      if (!requestId) {
        throw new Error('Join request id is required to decline.');
      }

      const payload = buildDeclineJoinRequestPayload({ declineReasonCode, declineReasonText });
      const result = await declinePartnerGroupChannelJoinRequest(requestId, payload);

      if (!result.success) {
        throw new Error(result.message || 'Failed to decline join request');
      }

      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
